var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 499.999 499.999",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    x2: 499.998,
    y1: 250,
    y2: 250
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#60aeff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#60aeff",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#60aeff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 135.323,
    x2: 443.298,
    y1: 102.267,
    y2: 410.242
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 249.999,
    cy: 249.999,
    fill: "url(#SVGID_1_)",
    r: 249.999,
    "data-original": "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m499.999 249.999c0-4.267-.107-8.509-.321-12.728l-88.523-88.523h-71.23l-17.855 63.464-62.815-62.813h-18.832l-24.281 53.6-54.252-54.253h-73.047l66.112 202.5 143.952 143.954c114.652-22.739 201.092-123.869 201.092-245.201z",
    fill: "url(#SVGID_2_)",
    opacity: 0.49,
    "data-original": "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m411.155 148.749-64.513 202.5h-56.216l-40.066-90.706-39.187 90.706h-56.218l-66.112-202.5h73.047l30.664 106.329 47.869-105.678h18.832l50.48 106.655 30.19-107.3z",
    fill: "#ffffff",
    "data-original": "#ffffff",
    className: ""
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7a24a753f5e711910ffec1bd5f67b4f8.svg";
export { ForwardRef as ReactComponent };